import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  banners: [],
  topGames: [],
  loading: false,
  error: null,
};

const interfaceSlice = createSlice({
  name: "interface",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.banners = action.payload.banners;
      state.topGames = action.payload.topGames;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
// const baseUrl = "https://staging.kumeo.com";

export const { requestStart, ApiSuccess,  } =
  interfaceSlice.actions;

export const LoadUserInterface = () => async (dispatch) => {
  try {
    dispatch(requestStart());

    const response = await axios.get("/public/interface");
    dispatch(ApiSuccess(response?.data));
  } catch (err) {
    toast.error(err?.response?.data?.message || err.message || " failed!");
  }
};

export default interfaceSlice.reducer;
